const computed = require('baobab').monkey;

module.exports = {
    promoText (state) {
        state.set(['slider', 'computed', 'text'], computed(
            ['slider', 'page'],
            (page = 1) => {
                switch (page % 4) {
                    case 1:
                        return {
                            title: 'Точность',
                            content: `Регулярная выверка информации специалистами call-центра
                                    и пешими картографами на местах`
                        };
                    case 2:
                        return {
                            title: 'Охват',
                            content: `Полная и актуальная информация о 2,4 млн российских компаний из 270 городов
                                 России, включая города-спутники`
                        };
                    case 3:
                        return {
                            title: 'Надежность',
                            content: `Data.2gis — один из Сервисов 2ГИС, который предоставляет 
                            доступ к официальным данным 2ГИС`
                        };
                    case 0:
                        return {
                            title: 'Возможности',
                            content: `Более подробная выборка (средний чек, количество филиалов 
                                или другие параметры и данные) 
                                также доступны в Личном кабинете`
                        };
                    default:
                        return {
                            title: 'Точность',
                            content: `Регулярная выверка информации специалистами call-центра
                                    и пешими картографами на местах`
                        };
                }
            }
        ));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/order/slider/index.js